function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fill: "#4F525A",
  fillRule: "evenodd",
  d: "M13.256 4.742a.148.148 0 01-.04-.125.147.147 0 01.073-.109l.48-.277a.9.9 0 00-.9-1.56l-.64.369a.15.15 0 01-.222-.106l-.24-1.43A1.794 1.794 0 009.992 0H4.227a1.795 1.795 0 00-1.775 1.505l-.24 1.43a.15.15 0 01-.224.106l-.637-.37a.901.901 0 00-.9 1.56l.48.279a.15.15 0 01.033.234A2.673 2.673 0 00.21 6.599v1.2c.002.615.38 1.167.954 1.39a.149.149 0 01.096.14v1.17a1.35 1.35 0 002.7 0v-1.05a.15.15 0 01.15-.15h6a.15.15 0 01.15.15v1.05a1.35 1.35 0 002.7 0V9.33a.15.15 0 01.095-.14c.574-.223.953-.774.955-1.39V6.6c0-.694-.272-1.36-.755-1.859zm-9.029-3.54h5.767c.294 0 .544.211.592.5l.287 1.725a.148.148 0 01-.148.172H3.496a.147.147 0 01-.114-.053.148.148 0 01-.034-.121L3.635 1.7c.05-.289.3-.5.592-.5zm7.384 6.6a.9.9 0 11.001-1.801.9.9 0 01-.001 1.801zm-9.9-.9a.9.9 0 11.263.636.901.901 0 01-.263-.637z"
});

function SvgCarIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 12
  }, props), _ref);
}

export default SvgCarIcon;